
/* eslint-disable */
const globModules = [
  {
    name: 'video-modal',
    loader: () => import('./modules/video-modal')
  },
  {
    name: 'video-modal',
    loader: () => import('./modules/video-modal')
  },
  {
    name: 'image-gallery-masthead',
    loader: () => import('./modules/image-gallery-masthead')
  },
  {
    name: 'product-catalog-row',
    loader: () => import('./modules/product-catalog-row')
  },
  {
    name: 'product-image-gallery-row',
    loader: () => import('./modules/product-image-gallery-row')
  },
  {
    name: 'featured-cta',
    loader: () => import('./modules/featured-cta')
  },
  {
    name: 'dealer-search',
    loader: () => import('./modules/dealer-search')
  },
  {
    name: 'header',
    loader: () => import('./modules/header')
  }
];

export default globModules;
